export default function Router($stateProvider, $urlRouterProvider) {
	"ngInject";

	$urlRouterProvider
		.when("/app/configurations", "/app/configurations/");

	$stateProvider
		.state({
			name: "configurations",
			url: "/app/configurations",
			template: "<configurations></configurations>"
		})
		.state({
            name: "configurations.list",
            url: "/",
            template: "<configuration-list></configuration-list>",
            resolve: {
                $title: () => "Configurations | UpReach Cloud"
            }
        })
		.state({
            name: "configurations.update",
            url: "/:cid/?:isNew",
            template: "<configuration-update></configuration-update>",
            resolve: {
                $title: () => "Configuration Update | UpReach Cloud"
            }
        })
        .state({
            name: "configurations.setup",
            url: "/setup/:cid/?:isNew",
            template: "<quick-setup></quick-setup>",
            resolve: {
                $title: () => "Configuration Setup | UpReach Cloud"
            }
        })
		.state({
            name: "configurations.create",
            url: "/create",
            template: "<configuration-update></configuration-update>",
            resolve: {
                $title: () => "Configuration Create | UpReach Cloud"
            }
        });
}


// WEBPACK FOOTER //
// ./sources/components/configurations/configurations-router.js